import React, { useEffect } from "react";
import { FaEye, FaRegHeart } from "react-icons/fa";
import { RiShoppingCartLine } from "react-icons/ri";
import Rating from "../Rating";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  add_to_card,
  add_to_wishlist,
  messageClear,
} from "../../store/reducers/cardReducer";
import toast from "react-hot-toast";
import CurrencyFormat from "../shared/CurrencyFormat";

const FeatureProducts = ({ products }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { errorMessage, successMessage } = useSelector((state) => state.card);

  const add_card = (id) => {
    if (userInfo) {
      dispatch(
        add_to_card({
          userId: userInfo.id,
          quantity: 1,
          productId: id,
        })
      );
    } else {
      navigate("/login");
    }
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
  }, [successMessage, errorMessage, dispatch]);

  const add_wishlist = (pro) => {
    dispatch(
      add_to_wishlist({
        userId: userInfo.id,
        productId: pro._id,
        name: pro.name,
        price: pro.price,
        image: pro.images[0],
        discount: pro.discount,
        rating: pro.rating,
        slug: pro.slug,
      })
    );
  };

  return (
    <div className="w-11/12 flex flex-wrap mx-auto">
      {/* Section Header */}
      <div className="w-full">
        <div className="text-center flex flex-col items-center text-3xl text-slate-600 font-bold pb-12">
          <h2>Los Más Vendidos</h2>
          <div className="w-24 h-1 bg-green-600 mt-4"></div>
        </div>
      </div>

      {/* Products Grid */}
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {products.map((p, i) => (
          <div
            key={i}
            className={
              "border group transition-all duration-500 hover:shadow-md hover:-mt-3 rounded-lg" +
              (p.discount ? " border-green-400" : "")
            }
          >
            {/* Product Image */}
            <div className="relative overflow-hidden h-[240px] flex justify-center items-center rounded-t-lg p-5">
              {p.discount && (
                <div className="flex justify-center items-center absolute text-white w-10 h-10 rounded-full bg-green-600 font-semibold text-xs left-2 top-2">
                  {p.discount}%
                </div>
              )}

              <img
                className="rounded-md object-contain max-h-full"
                src={p.images[0]}
                alt={p.name}
              />

              {/* Hover Actions */}
              <ul className="flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3">
                <li
                  onClick={() => add_wishlist(p)}
                  className="w-10 h-10 cursor-pointer bg-white flex justify-center items-center rounded-full hover:bg-green-600 hover:text-white hover:rotate-[720deg] transition-all"
                >
                  <FaRegHeart />
                </li>
                <Link
                  to={`/product/details/${p.slug}`}
                  className="w-10 h-10 cursor-pointer bg-white flex justify-center items-center rounded-full hover:bg-green-600 hover:text-white hover:rotate-[720deg] transition-all"
                >
                  <FaEye />
                </Link>
                <li
                  onClick={() => add_card(p._id)}
                  className="w-10 h-10 cursor-pointer bg-white flex justify-center items-center rounded-full hover:bg-green-600 hover:text-white hover:rotate-[720deg] transition-all"
                >
                  <RiShoppingCartLine />
                </li>
              </ul>
            </div>

            {/* Product Info */}
            <div className="py-3 text-slate-600 px-4">
              <h2 className="font-bold truncate">{p.name}</h2>
              <div className="flex justify-between items-center">
                <span
                  className={`text-md font-semibold ${
                    p.discount && "text-green-600 text-lg"
                  }`}
                >
                  <CurrencyFormat
                    value={p.price - (p.price * p.discount) / 100}
                  />
                </span>
                <div className="flex">
                  <Rating ratings={p.rating} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureProducts;
